import type { Member } from "common/types";

import RemoveMember from "./RemoveMember";
import RevokeInvite from "./RevokeInvite";
import UpdatePermissions from "./UpdatePermissions";

interface MemberActionsProps {
  member: Member;
  action: "remove" | "revoke" | "permissions";
  onClose: () => void;
}

export default function MemberActions({
  member,
  action,
  onClose,
}: MemberActionsProps) {
  if (action === "remove") {
    return (
      <RemoveMember
        email={member.email}
        memberId={member.customer_id}
        onBack={onClose}
      />
    );
  }

  if (action === "revoke") {
    return <RevokeInvite inviteToken={member.token} onBack={onClose} />;
  }

  if (action === "permissions") {
    return (
      <UpdatePermissions
        currentPermissions={member.permissions}
        email={member.email}
        memberId={member.customer_id}
        onClose={onClose}
      />
    );
  }
}
